export const style = {
    colors: {
        primary: "#003F80",
        secondary: "#D9D9D9",
        sensebot: "#FB4747",
        commandCenter: "#76B900",
        rad: "#883C8F",
        info: "#0095DE",
        success: "#0EA447",
        warning: "#FFD700",
        average: "#FFA059",
        nexus: "#f0811d",
        high: "#FF780A",
        critical: "#E02F44",
        light: {
            "bg-primary": "#f5f5f6",
            "bg-secondary": "#ffffff",
            "font-color": "#202124"
        },
        dark: {
            "bg-primary": "#111217",
            "bg-secondary": "#181B1F",
            "font-color": "#FFFFFF"
        }
    },
    screens: {
        "x-small": "479px",
        small: "767px",
        medium: "767px",
        large: "1219px",
        "x-large": "1220px"
    },
    paddings: {
        small: "8px",
        medium: "16px",
        large: "24px"
    },
    margins: {
        small: "8px",
        medium: "16px",
        large: "24px"
    },
    font: {
        family: {
            bold: "'Poppins-Bold', Arial, sans-serif",
            semiBold: "'Poppins-SemiBold', Arial, sans-serif",
            regular: "'Poppins-Regular', Arial, sans-serif",
            medium: "'Poppins-Medium', Arial, sans-serif",
            light: "'Poppins-Light', Arial, sans-serif",
        },
        size: {
            h1: '40px',
            h2: '36px',
            h3: '24px',
            h4: '20px',
            p: '16px',
        }
    }
}

type theme = "light" | "dark"

export var theme: theme = "light";
